import ResellerService from '_services/rest/modules/reseller';

export default {
  state: {
    reseller: null,
    resellerList: null,
  },
  mutations: {
    setResellerList(state, response) {
      state.resellerList = response;
    },
    setReseller(state, response) {
      state.reseller = response;
    },
    setResellerAddress(state, address) {
      const [street, number] = address.address.split(', ');
      address.street = street;
      address.number = number;
      state.reseller.address = address;
    },
  },
  actions: {
    getResellerList({ commit }, params) {
      return ResellerService.getList(params)
        .then(response => {
          commit('setResellerList', response);
        });
    },
    getReseller({ commit }, params) {
      return ResellerService.getResellerById(params)
        .then(reseller => {
          commit('setReseller', reseller);
          commit('setResellerAddress', reseller.address);
        })
        .catch(error => {
          throw error.message;
        });
    },
    getResellerAddress({ commit }, addresses) {
      commit('setResellerAddress', addresses);
    },
  },
};
